import { Switch } from "@shared/components/DataEntry";

import { useActiveAgreementSwitch, useActiveBestSellerAgreementSwitch } from "./controller";
import { ActiveAgreementSwitchProps } from "./types";

export function ActiveAgreementSwitch(props: ActiveAgreementSwitchProps) {
  const { isActive, isPending, toggle } = useActiveAgreementSwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
export function ActiveBestSellerAgreementSwitch(props: ActiveAgreementSwitchProps) {
  const { isActive, isPending, toggle } = useActiveBestSellerAgreementSwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
